import React, { useEffect } from 'react';

import './ProjectModal.css';

const ProjectModal = ({ project, onClose }) => {
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleEscape);
        document.body.style.overflow = 'hidden';

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = '';
        };
    }, [onClose]);

    return (
        <div class="modal-overlay" onClick={onClose}>
            <div class="modal-content" onClick={(e) => e.stopPropagation()}>
                <button class="modal-close" onClick={onClose}>&times;</button>
                <h2 class="modal-title">{project.name}</h2>
                <p class="modal-desc">{project.desc}</p>
                <p class="modal-detail">{project.detail}</p>
            </div>
        </div>
    );
};

export default ProjectModal;
